import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import InputAdornment from '@material-ui/core/InputAdornment';
import Icon from '../../../../core/Icon';
import LookupDialog from '../binding/LookupDialog';
import { makeStyles } from '@material-ui/core';
var useStyles = makeStyles({
  inputAdornmentForMap: {
    position: 'absolute',
    top: 'calc(50% - 25px)',
    right: '10px'
  },
  inputForMap: {
    background: 'white'
  }
});

var LookupButton = function LookupButton(_ref) {
  var fieldId = _ref.fieldId,
      _ref$marginRight = _ref.marginRight,
      marginRight = _ref$marginRight === void 0 ? 0 : _ref$marginRight,
      _ref$isForMap = _ref.isForMap,
      isForMap = _ref$isForMap === void 0 ? false : _ref$isForMap;

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      open = _useState2[0],
      setOpen = _useState2[1];

  var onLookup = function onLookup() {
    setOpen(true);
  };

  var onClose = function onClose(e, reason) {
    if (reason && reason == 'backdropClick') return;
    setOpen(false);
  };

  var classes = useStyles({});
  return React.createElement(React.Fragment, null, React.createElement(InputAdornment, {
    position: "end",
    style: {
      marginRight: marginRight || 0
    },
    className: isForMap ? classes.inputAdornmentForMap : null
  }, React.createElement(Icon, {
    type: "search",
    buttonSize: "small",
    onClick: onLookup,
    className: isForMap ? classes.inputForMap : null
  })), open && React.createElement(LookupDialog, {
    onClose: onClose,
    fieldId: fieldId
  }));
};

export default React.memo(LookupButton);